'use client';

import { useForBinding } from '../contexts/ForBindingContext';

export const useForBindingParams = () => {
	const { forBindingParams, isForBinding } = useForBinding();
	return { forBindingParams, isForBinding };
};

// indica que a tela opera sempre no contexto do owner,
// nunca no contexto do binding user — equivalente ao owner-only do backend.
export const useOwnerOnlyContext = () => {
	return { forBindingParams: {} as Record<string, never>, isForBinding: false };
};
